import {AdminAxios} from "../../common/Axios";

const isInit = false;
const ACTION_URL = '/adver/campaign'
const BUDGET_UPDATE = '/config/budget'
const BUDGET_INFO = 'budget'
const BUDGET_SCHEDULER = '/{campaignId}/budget/schedulers'
const DELETE_BUDGET_SCHEDULER = '/{campaignId}/budget/schedulers/{schedulerId}'

export async function updateCampaignBudget(campaignInfo) {
  let returnVal = null;
  if(isInit) {
    return true;
  }

  await AdminAxios('PUT', ACTION_URL + '/' + campaignInfo.campaignId + BUDGET_UPDATE, campaignInfo)
    .then((response) => {
      const { statusCode } = response;
      if (statusCode === 200) {
        returnVal = true;
      } else {
        returnVal = false;
      }
    }).catch((e) => returnVal = false)
  return returnVal;
};

export async function selBudgetInfo(userId) {
  let returnVal = null;
  await AdminAxios('GET', ACTION_URL+'/'+userId+'/'+BUDGET_INFO)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};
export async function selCampaignBudgetScheduleHistory(campaignId) {
  let returnVal = null;
  await AdminAxios('GET', ACTION_URL + BUDGET_SCHEDULER.replaceAll('{campaignId}', campaignId))
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};
export async function reserveCampaignBudget(campaignId, request) {
  let returnVal = null;
  await AdminAxios('PUT', ACTION_URL + BUDGET_SCHEDULER.replaceAll('{campaignId}', campaignId), request)
  .then((response) => {
    const { statusCode } = response;
    if(statusCode === 200){
      returnVal = true;
    }else{
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

export async function cancelCampaignBudgetSchedule(campaignId, schedulerId) {
  let returnVal = null;
  await AdminAxios('DELETE', ACTION_URL + DELETE_BUDGET_SCHEDULER.replaceAll('{campaignId}', campaignId).replaceAll('{schedulerId}', schedulerId))
  .then((response) => {
    const { statusCode } = response;
    if(statusCode === 200){
      returnVal = true;
    }else{
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};